/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";

const style = css`
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const CTAGroup = ({ children }) => <div css={style}>{children}</div>;

export default CTAGroup;
